import React from "react";
import { CoreText } from "@oscarrf2/goo-ds";

// Portfolio wrapper around the DS CoreText that layers the Figma "Engram" text
// treatment on top of the base typography: a tokenized text fill plus a
// -webkit-text-stroke and drop text-shadow (with paint-order: stroke fill).
//
// Everything is driven by the Figma token names already present in
// src/styles/ds-themes.css — no hardcoded colors. The stroke/effect tokens
// resolve to transparent / zero outside the engram theme, so the treatment
// auto-hides in light/trace and only lights up under [data-theme="engram"].
//
// Treatments map to the Figma "typography-effect-{primary,secondary}-{md,lg}"
// styles:
//   secondary-md -> engram secondary stroke (md width) + secondary md drop
//   secondary-lg -> engram secondary stroke (lg width) + secondary lg drop
//   primary-md   -> engram primary stroke (md width) + primary md drop,
//                   the treatment Figma puts on figures and other emphatic copy
// The actual token wiring lives in the .pf-text-engram* classes in index.css.
const TREATMENT_CLASS = {
  "secondary-md": "pf-text-engram pf-text-engram--secondary-md",
  "secondary-lg": "pf-text-engram pf-text-engram--secondary-lg",
  "primary-md": "pf-text-engram pf-text-engram--primary-md",
  none: "",
};

function PortfolioText({
  children,
  as = "p",
  variant = "body-md-regular",
  align = "left",
  colorTokenName = "--typography-text-primary",
  treatment = "secondary-md",
  className = "",
}) {
  const treatmentClass =
    TREATMENT_CLASS[treatment] ?? TREATMENT_CLASS["secondary-md"];
  const classes = [treatmentClass, className].filter(Boolean).join(" ");

  return (
    <CoreText
      as={as}
      style={variant}
      align={align}
      colorTokenName={colorTokenName}
      className={classes}
    >
      {children}
    </CoreText>
  );
}

export default PortfolioText;
